/**
 * GET `admin/jobs` — жив ли фоновый воркер и чем закончился последний
 * запуск каждой задачи. alive: false — триалы не закрываются, сообщения
 * копятся в очереди.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_WORKER} from '../mocks';
import {asObj, toJobRun} from '../toSystem';
import type {WorkerStatus} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getWorkerStatus = async (): Promise<WorkerStatus> => {
  if (!apiEnabled) {
    await sleep(200);
    return MOCK_WORKER;
  }
  const r = asObj(await http('admin/jobs', {skipCaseConversion: true}));
  return {
    alive: r.alive === true,
    lastHeartbeatAt: typeof r.lastHeartbeatAt === 'string' ? r.lastHeartbeatAt : null,
    lastRuns: (Array.isArray(r.lastRuns) ? r.lastRuns : []).map(toJobRun),
  };
};
